import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { looksLikeJwt, finishSocialLogin } from "../SocialAuth/socialRouting";

/**
 * Safety-net route for Apple's registered Return URL (/apple-login).
 * The normal web flow uses the popup SDK and resolves inline in SignIn/
 * Register, so this component usually isn't reached. If Apple (or a future
 * backend redirect) ever lands here with ?access=&refresh= tokens, finish
 * the login the same way as Google; otherwise send the user to sign-in.
 */
export default function AppleCallback() {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const run = async () => {
      const params = new URLSearchParams(window.location.search);
      const access = params.get("access");
      const refresh = params.get("refresh");

      if (!looksLikeJwt(access) || !looksLikeJwt(refresh)) {
        navigate("/sign-in", { replace: true });
        return;
      }

      await finishSocialLogin({
        access,
        refresh,
        navigate,
        backTo: location.state?.from,
        providerName: "Apple",
      });
    };

    run();
  }, [navigate, location]);

  return <div>Signing in...</div>;
}
